import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { MerchantApplicationDocumentDTO } from '../../data/dtos/merchant-application-document.dto';

const routeRoot = 'merchantApplicationDocuments';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    getApplicationDocumentsById: {
        method: 'GET',
        url: `${baseRoute}/:applicationId/documents`
    },
    saveApplicationDocuments: {
        method: 'POST',
        url: `${baseRoute}/SaveApplicationDocuments`
    },
};

export interface IMerchantApplicationDocuments {
    getApplicationDocumentsById(): Promise<MerchantApplicationDocumentDTO[]>
    saveApplicationDocuments(request: any): Promise<MerchantApplicationDocumentDTO[]>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function MerchantApplicationDocumentApi(): IMerchantApplicationDocuments {
    return createActions(actions);
}
